module.exports = __webpack_public_path__ + "img/15045348000172.294cf4b4.png";